import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportChangeStructureStatePayload } from '../types';
import {
  REPORT_CHANGE_STRUCTURE_STATE_API_URL,
  REPORT_CHANGE_STRUCTURE_STATE_MUTATION,
} from '../constants';

export default function useReportChangeStructureStateMutation(): IContextMutationResult<void, Error, IReportChangeStructureStatePayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IReportChangeStructureStatePayload>({
    mutationKey: [REPORT_CHANGE_STRUCTURE_STATE_MUTATION],
    mutationFn: ({ options: { reportType, permission }, tabId, ...payload }) => fetchPut<void>(
      REPORT_CHANGE_STRUCTURE_STATE_API_URL,
      payload,
      {
        permission,
        urlParams: {
          reportType,
          tabId,
        },
      },
    ),
  });
}
